module.exports = __webpack_public_path__ + "static/img/jjfa_02.75e9093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jjfa_02.png
// module id = 5xKO
// module chunks = 1